import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import RapportMoney from './rapportMoney/RapportMoney';
import RapportInformation from './rapportInformation/RapportInformation';
import { NdoePage, NdoePageHeader, NdoeToolbar } from '../../../components/ndoe';

const { RangePicker } = DatePicker;

const RapportCaisse = () => {
    const [dates, setDates] = useState(['', '']);

    const formatDate = (date) => (date ? date.format('YYYY-MM-DD') : null);

    const handleDateChange = (dates) => {
        // RangePicker renvoie null quand on efface la sélection (allowClear).
        setDates(dates ? dates.map(formatDate) : ['', '']);
    };

    const [start_date, end_date] = dates;

    return (
        <NdoePage className="rapportCaisse">
            <NdoePageHeader
                eyebrow="Rapports"
                title="Rapport de caisse"
                subtitle="Synthèse des ventes, dépenses et de l'activité sur la période"
            />

            <NdoeToolbar
                search={
                    <RangePicker
                        format="YYYY-MM-DD"
                        style={{ width: '100%', maxWidth: 360 }}
                        placeholder={['Depuis', "Jusqu'à"]}
                        onChange={handleDateChange}
                        allowClear
                    />
                }
            />

            <RapportMoney start_date={start_date} end_date={end_date} />
            <RapportInformation start_date={start_date} end_date={end_date} />
        </NdoePage>
    );
};

RapportCaisse.propTypes = {
    start_date: PropTypes.string,
    end_date: PropTypes.string,
};

export default RapportCaisse;
